module.exports = __webpack_public_path__ + "img/ic_serve_bottom_left_img.f7674e0d.png";